export default (products: any[]) =>
  products.filter((product) => !product?.hidden);
